export default "__VITE_ASSET__2fc5cccb__"